import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@ngneat/reactive-forms';
import { BehaviorSubject, Subject } from 'rxjs';
import { HttpApiService } from '../services/http-api.service';
import { PageModel } from '../utils/interfaces/page-model';
import { Pagination } from '../utils/interfaces/pagination';
import { IAgent, IAgentDetail } from './interfaces/agent.interface';

@Injectable({
  providedIn: 'root',
})
export class AgentService {
  agentTypes$ = new BehaviorSubject<AgentType[]>([]);
  updateAgentTypes$ = new Subject<any>();
  agentTypes: AgentType[] = [];

  constructor(private http: HttpApiService, private ngFb: FormBuilder) {}

  getType() {
    return this.http.post<AgentType[]>(`api/v1/agent/get/type`, {});
  }

  setType(data: AgentType[]) {
    this.agentTypes$.next(data);
  }

  getSharedholder(params: PageModel) {
    return this.http.get<Pagination<Agent[]>>(`api/v1/agent/get/shareholder`, { params });
  }

  /**
   * get Agent Downline
   * @param params PageModel, ?typeAgentId={typeAgentId}order_by=prefix&sort=asc
   * @returns Obserable
   */
  getPresetAgent(agent_code: string) {
    return this.http.get(`api/v1/agent/get/preset/game?agent_code=${agent_code}`);
  }
  setPresetAgent(value: any) {
    return this.http.post(`api/v1/agent/set/preset/game`, value);
  }
  usingFakeSlot(agent_code: string, enable: boolean) {
    return this.http.put(`api/v1/agent/use-slot-fake?agent_code=${agent_code}&use=${enable}`, {});
  }
  getCurrency() {
    return this.http.get<ICurrency[]>(`api/v1/agent/get/currency`);
  }
  getProfitInfo(agentCode: string, currency: string) {
    return this.http.get<AgentInfo>(`api/v1/agent/get/info`, {
      params: { agent_code: agentCode, currency: currency },
    });
  }

  getProfitSharing(agentCode: string, currency: string) {
    return this.http.get<IProfigSharing>(`api/v1/agent/get/profit-sharing`, {
      params: { agent_code: agentCode, currency: currency },
    });
  }

  updateGameEnable(betlimitProfit: any, agentCode: string) {
    return this.http.put<any>(`api/v1/agent/update/game-enable`, betlimitProfit, {
      params: { agent_code: agentCode },
    });
  }

  getAgentDownline(params: PageModel) {
    return this.http.get<Pagination<Agent[]>>(`api/v1/agent/get/downline`, { params });
  }
  getAgentDownline1lvl(params: PageModel) {
    return this.http.get<Pagination<Agent[]>>(`api/v1/agent/get/downline/code`, { params });
  }

  getAgentById(ask4betAgentId: number) {
    return this.http.get<Agent>(
      `api/v1/agent/get/by_ask4betAgentId?ask4betAgentId=${ask4betAgentId}`
    );
  }

  postSharedholder(model: AgentModel) {
    return this.http.post(`api/v1/agent/create/shareholder`, model);
  }

  postDownline(model: AgentModel) {
    return this.http.post(`api/v1/agent/create/downline`, model);
  }

  getAll(params: PageModel = {}) {
    return this.http.get<Pagination<Agent[]>>(`api/v1/agent/get/all`, { params });
  }

  getSelf() {
    return this.http.get<Agent>(`api/v1/agent/get/self`);
  }

  // ---------------------------------------------------------------
  getShareSettingAMB(form: IAgent.AskmebetSetting) {
    return this.http.post(`api/v1/agent/get/shareSettingAMB`, form);
  }
  getShareSettingKlotto(form: any) {
    // IAgent.ShareSettingKlotto
    return this.http.post(`api/v1/agent/get/shareSettingKlotto`, form);
  }
  /**
   * Get Limit Setting Template
   * @param params api/ask4bet/limit_setting/templete?agent_id={agent_id}&member_id={member_id}
   * @returns Obs
   */
  getLimitSettingTemplate(params: any) {
    return this.http.get(`api/ask4bet/limit_setting/templete`, { params });
  }
  getModelConfigAdmin() {
    return this.http.get(`api/v1/agent_config/get/model_config_admin`);
  }
  getModelConfig() {
    return this.http.get(`api/v1/agent_config/get/model_config`);
  }
  /**
   *
   * @param providerName amb,amb_super_api,568win,bethub,klotto,gclub,tfgaming
   * @returns
   */
  getByProviderName(providerName: string) {
    return this.http.get<IAgent.IProvider[]>(
      `api/ask4bet/provider_game/get_by_provider_name?provider_name=${providerName}`
    );
  }
  createGroupGame(): FormGroup<any> {
    return this.ngFb.group({
      game_code: [''],
      game_name: [''],
      percent_own: [0],
      percent_max: [0],
      percent_board: [0],

      game_id: [null],
      enabled: [false],
      statusActive: [true],
      game_img: [''],
      game_type: [''],

      betlimitlists: [undefined],
      bet_limit_id: [undefined],
      ID: [''], // casino
      min_HUP_OU_OE: [0], // sport
      max_HUP_OU_OE: [0], // sport
      min_DC1X2: [0], // sport
      max_DC1X2: [0], // sport
      min_any: [0], // sport
      max_any: [0], // sport
      min_per_macth: [0], // sport, esport
      max_per_macth: [0], // sport, esport
    });
  }
  createSettingGroupGame() {
    return this.ngFb.group({
      bet_limit_id: [undefined],
      min: [0],
      max: [0],
    });
  }
  putAgentDownlinePassword(id: number, model: any) {
    return this.http.post(`api/admin/${id}/reset_password`, model);
  }

  postModifyCredit(agentId: number, model: ModifyCreditModel) {
    return this.http.post(`api/v1/agent/modify_credit?agent_id=${agentId}`, model);
  }

  putAgentStatusActive(agentAsk4betId: number) {
    return this.http.put(`api/v1/agent/status/active?agentAsk4betId=${agentAsk4betId}`, {});
  }
  putAgentStatusInactive(agentAsk4betId: number) {
    return this.http.put(`api/v1/agent/status/inactive?agentAsk4betId=${agentAsk4betId}`, {});
  }
  deleteAgent(agentAsk4betId: number) {
    return this.http.delete(`api/v1/agent/status/remove?agentAsk4betId=${agentAsk4betId}`);
  }

  refreshAMB(agentId: number) {
    return this.http.get(`api/v1/agent/refresh/amb?agent_id=${agentId}`);
  }
  refreshKlotto(agentId: number) {
    return this.http.get(`api/v1/agent/refresh/klotto?agent_id=${agentId}`);
  }
  generateKey(agentId: number) {
    return this.http.get(`api/v1/agent/${agentId}/issue_secret`);
  }
  getMaintanace(agentId: number) {
    return this.http.get(`api/ask4bet/game/maintenance_time?agent_id=${agentId}`);
  }

  getAgentShareSettings(agentId: number) {
    return this.http.get(`api/v1/agent/share_setting?agent_id=${agentId}`);
  }

  // postShareSettingSeamless() {
  //   return this.http.post<ShareSettingSeamless[]>(`api/v1/agent/get/shareSettingSeamless`, {});
  // }

  // postShareSettingSeamlessAgent() {
  //   return this.http.post<ShareSettingSeamlessAgent[]>(`api/v1/agent/get/shareSettingSeamless/noPercent`, {});
  // }

  getBetLimitMember(member_id: number) {
    return this.http.get<MemberSeamlessBetlimit>(`api/member/bet_limit?member_id=${member_id}`);
  }

  getTransacionByAgentId(agent_id: number) {
    return this.http.get<AgentTransactionUplineDownline[]>(
      `api/v1/agent/transaction_agent?agentAsk4betId=${agent_id}`
    );
  }
  // -------------------- 3/9/2024 -------------------------
  getPercentMapData(agent_code: string, game_type: string) {
    return this.http.get<AgentUser>(
      `api/v1/agent/get/lvl-sharing-profit/percent?agent_code=${
        agent_code || ''
      }&game_type=${game_type}`
    );
  }
  getPercentMapDataNew(agent_code: string, game_type: string) {
    return this.http.get<AgentUser>(
      `api/v1/agent/get/lvl-sharing-profit/percent-new?agent_code=${
        agent_code || ''
      }&game_type=${game_type}`
    );
  }
  getAgentUserBycode(agent_code: string) {
    return this.http.get<AgentUser>(`api/v1/agent/get/agent-user?agent_code=${agent_code || ''}`);
  }
  getAgentReloadCreate(agent_code: string, currency: string) {
    return this.http.get<IProfigSharing>(
      `api/v1/agent/get/reload/create?agent_code=${agent_code || ''}&currency=${currency}`
    );
  }
  getAgentReloadUpdate(agent_code: string, agent_code_downline: string) {
    return this.http.get<IProfigSharing>(
      `api/v1/agent/get/reload/update?agent_code=${
        agent_code || ''
      }&downline_agent_code=${agent_code_downline}`
    );
  }
  createAgent(type_agent_name: string, payload: any) {
    return this.http.post<any>(`api/v1/agent/create?type_agent_name=${type_agent_name}`, payload);
  }
  updateAgent(agent_code: string, type_agent_name: string, payload: any) {
    return this.http.put<any>(
      `api/v1/agent/edit?agent_code=${agent_code}&type_agent_name=${type_agent_name}`,
      payload
    );
  }
}
export interface AgentInfo {
  agent_code: string;
  agent_contact_name: string;
  agent_name: string;
  count_member: number;
  credit_init: number;
  credit_remaining: number;
  credit_used: number;
  currency: string;
  upline: string;
  create_dt: string;
  type_agent: number;
  type_agent_name: string;
  member_credit: number;
  agent_downline_credit: number;
  using_pghard: boolean;
}
export interface ICurrency {
  img_flag: string;
  currency: string;
  supported: boolean;
  description: string;
  game_count: number;
}

export interface AgentType {
  typeId: number;
  typeName: AgentTypeKey;
  typeDetail: string;
}

export const AgentType = {
  shareholder: 'SHAREHOLDER',
  senior_agent: 'SENIOR_AGENT',
  master_agent: 'MASTER_AGENT',
  agent: 'AGENT',
};

export const AgentTypeUpline = {
  shareholder: '',
  senior_agent: 'shareholder',
  master_agent: 'senior_agent',
  agent: 'master_agent',
};
export interface ImaintenanceTime {
  Id: number;
  agent_id: number;
  agentName: string;
  game: string;
  active: boolean;
  status: string;
  update_date: Date;
}
export type AgentTypeKey = keyof typeof AgentType;

export interface AgentModel {
  agentName: string;
  partnerName: string;
  password: string;
  typeAgent?: number; // use create downline
  credit_init: number; // use create downline
  agentAsk4BetConfig?: AgentAsk4BetConfigModel;
  agentAsk4betConfigByAdmin?: AgentConfigByAdminModel; // use create shareholder
  askmebetSetting?: AskmebetSettingModel; // use create shareholder
}

export interface AskmebetSettingModel {
  agent_name: string;
  password: string;
  key: string;
  hash: string;
  client: string;
  end_point: string;
  url_for_bypass: string;
}

export interface AgentAsk4BetConfigModel {
  deposit_on: boolean;
  deposit_min: number;
  deposit_decimal: boolean;
  withdraw_on: boolean;
  withdraw_min: number;
  withdraw_decimal: boolean;
  member_phone_number_duplicate: boolean;
  member_bank_account_duplicate: boolean;
  member_ipaddress_duplicate: boolean;
  turn_over: number;
}

export interface AgentConfigByAdminModel {
  loyalty_system_on: boolean;
  recommend_system_on: boolean;
  tournament_system_on: boolean;
  leaderboard_system_on: boolean;
}

export interface Agent {
  id: number;
  agent_code: string;
  agent_name: string;
  agent_contact_name: string;
  count_member: number;
  member_postfix: number;
  type_agent: number;
  currency: string;
  typeName: string;
  typeDetail: string;
  credit_init: number;
  credit_remaining: number;
  credit_used: number;
  status: string;
  create_by: number;
  create_dt: string;
  create_name: string;
  update_by?: any;
  update_dt?: any;
  update_name?: any;
  upline: string;
  upline_id?: number;
  agent_name_upline?: string;
  admin_main?: any;
  using_pghard: boolean;
  [key: string]: any;
}

export interface AgentAdminMain {
  id: number;
  username: string;
  name: string;
}

export interface AgentAMB {
  agent_name: string;
  credit_init: number;
  credit_remaining: number;
  credit_used: number;
  currency: string;
}

export interface AgentKlotto {
  agent_name: string;
  credit_init: number;
  credit_remaining: number;
  credit_used: number;
}

export const allowAgents = {
  shareholder: [],
  senior_agent: ['Shareholder'],
  master_agent: ['Shareholder', 'Senior Agent'],
  agent: ['Shareholder', 'Senior Agent', 'Master Agent'],
};

export interface ModifyCreditModel {
  action: ModifyCreditType;
  amount: number;
}

export type ModifyCreditType = 'add' | 'reduce';

export interface AgentLimitSetting {
  amb: Amb;
  klotto: Klotto;
}

interface Klotto {
  limit_setting: KlottoLimitSetting;
}

interface KlottoLimitSetting {
  Id: number;
  THAI_3_TOP_maxBet: number;
  THAI_3_BOTTOM_maxBet: number;
  THAI_3_FRONT_maxBet: number;
  THAI_3_ROLL_maxBet: number;
  THAI_2_TOP_maxBet: number;
  THAI_2_BOTTOM_maxBet: number;
  THAI_1_TOP_maxBet: number;
  THAI_1_BOTTOM_maxBet: number;
  THAIBANK_3_TOP_maxBet: number;
  THAIBANK_3_BOTTOM_maxBet: number;
  THAIBANK_3_FRONT_maxBet: number;
  THAIBANK_3_ROLL_maxBet: number;
  THAIBANK_2_TOP_maxBet: number;
  THAIBANK_2_BOTTOM_maxBet: number;
  THAIBANK_1_TOP_maxBet: number;
  THAIBANK_1_BOTTOM_maxBet: number;
  VNM_3_TOP_maxBet: number;
  VNM_3_BOTTOM_maxBet: number;
  VNM_3_ROLL_maxBet: number;
  VNM_2_BOTTOM_maxBet: number;
  VNM_2_TOP_maxBet: number;
  VNM_1_TOP_maxBet: number;
  VNM_1_BOTTOM_maxBet: number;
  LAO_3_TOP_maxBet: number;
  LAO_3_ROLL_maxBet: number;
  LAO_2_TOP_maxBet: number;
  LAO_2_BOTTOM_maxBet: number;
  LAO_1_TOP_maxBet: number;
  LAO_1_BOTTOM_maxBet: number;
  MYS_3_TOP_maxBet: number;
  MYS_3_ROLL_maxBet: number;
  MYS_2_TOP_maxBet: number;
  MYS_2_BOTTOM_maxBet: number;
  MYS_1_TOP_maxBet: number;
  MYS_1_BOTTOM_maxBet: number;
  STOCK_3_TOP_maxBet: number;
  STOCK_3_ROLL_maxBet: number;
  STOCK_2_TOP_maxBet: number;
  STOCK_2_BOTTOM_maxBet: number;
  STOCK_1_TOP_maxBet: number;
  STOCK_1_BOTTOM_maxBet: number;
  YEEKEE_3_TOP_maxBet: number;
  YEEKEE_3_ROLL_maxBet: number;
  YEEKEE_2_TOP_maxBet: number;
  YEEKEE_2_BOTTOM_maxBet: number;
  YEEKEE_1_TOP_maxBet: number;
  YEEKEE_1_BOTTOM_maxBet: number;
  update_dt: string;
  create_dt: string;
  member_id?: any;
  agent_id: number;
  update_by: number;
}

interface Amb {
  limit_setting: AMBLimitSetting;
  limit_setting_lotto: AMBLimitSettingLotto;
}

interface AMBLimitSetting {
  Id: number;
  casino_ag_limit: number;
  casino_ag_enable: boolean;
  casino_ab_limit: number;
  casino_ab_enable: boolean;
  casino_bg_limit: number;
  casino_bg_enable: boolean;
  casino_bt_limit: number;
  casino_bt_enable: boolean;
  casino_cr_limit: number;
  casino_cr_enable: boolean;
  casino_dg_limit: number;
  casino_dg_enable: boolean;
  casino_eb_limit: number;
  casino_eb_enable: boolean;
  casino_gc_limit: number;
  casino_gc_enable: boolean;
  casino_gd_limit: number;
  casino_gd_enable: boolean;
  casino_pm_limit: number;
  casino_pm_enable: boolean;
  casino_pt_limit: number;
  casino_pt_enable: boolean;
  casino_sa_limit: number;
  casino_sa_enable: boolean;
  casino_sexy_limit: number;
  casino_sexy_enable: boolean;
  game_enable: boolean;
  multi_amb_enable: boolean;
  poker_og_enable: boolean;
  sportsBook_enable: boolean;
  sportsBook_hdpOuOe_maxPerBet: number;
  sportsBook_hdpOuOe_maxPerMatch: number;
  sportsBook_oneTwoDoubleChance_maxPerBet: number;
  sportsBook_others_maxPerBet: number;
  sportsBook_outright_maxPerMatch: number;
  step_parlay_enable: boolean;
  step_parlay_maxBetPerDay: number;
  step_parlay_maxMatchPerBet: number;
  step_parlay_maxPayPerBill: number;
  step_parlay_maxPerBet: number;
  step_parlay_minMatchPerBet: number;
  step_parlay_minPerBet: number;
  step_enable: boolean;
  step_maxBetPerDay: number;
  step_maxMatchPerBet: number;
  step_maxPayPerBill: number;
  step_maxPerBet: number;
  step_minMatchPerBet: number;
  step_minPerBet: number;
  other_es_enable: boolean;
  other_hg_enable: boolean;
  other_tg_enable: boolean;
  other_m2_enable: boolean;
  other_m2_maxBetPerDay: number;
  other_m2_maxBetPerMatchHDP: number;
  other_m2_maxMatchPerBet: number;
  other_m2_maxPayPerBill: number;
  other_m2_maxPerBet: number;
  other_m2_maxPerBetHDP: number;
  other_m2_minMatchPerBet: number;
  other_m2_minPerBet: number;
  other_m2_minPerBetHDP: number;
  update_dt: string;
  create_dt: string;
  member_id?: any;
  agent_id: number;
  update_by: number;
  update_on_amb: boolean;
}

interface AMBLimitSettingLotto {
  Id: number;
  thai_enable: boolean;
  thai_cut_of_time: string;
  thai_1BOT_max: number;
  thai_1BOT_payout: number;
  thai_1BOT_discount: number;
  thai_1TOP_max: number;
  thai_1TOP_payout: number;
  thai_1TOP_discount: number;
  thai_2BOT_max: number;
  thai_2BOT_payout: number;
  thai_2BOT_discount: number;
  thai_2BOT_OE_max: number;
  thai_2BOT_OE_payout: number;
  thai_2BOT_OE_discount: number;
  thai_2BOT_OU_max: number;
  thai_2BOT_OU_payout: number;
  thai_2BOT_OU_discount: number;
  thai_2TOD_max: number;
  thai_2TOD_payout: number;
  thai_2TOD_discount: number;
  thai_2TOP_max: number;
  thai_2TOP_payout: number;
  thai_2TOP_discount: number;
  thai_2TOP_OE_max: number;
  thai_2TOP_OE_payout: number;
  thai_2TOP_OE_discount: number;
  thai_2TOP_OU_max: number;
  thai_2TOP_OU_payout: number;
  thai_2TOP_OU_discount: number;
  thai_3BOT_max: number;
  thai_3BOT_payout: number;
  thai_3BOT_discount: number;
  thai_3TOD_max: number;
  thai_3TOD_payout: number;
  thai_3TOD_discount: number;
  thai_3TOP_max: number;
  thai_3TOP_payout: number;
  thai_3TOP_discount: number;
  thai_3TOP_OE_max: number;
  thai_3TOP_OE_payout: number;
  thai_3TOP_OE_discount: number;
  thai_3TOP_OU_max: number;
  thai_3TOP_OU_payout: number;
  thai_3TOP_OU_discount: number;
  thai_4TOD_max: number;
  thai_4TOD_payout: number;
  thai_4TOD_discount: number;
  thai_4TOP_max: number;
  thai_4TOP_payout: number;
  thai_4TOP_discount: number;
  thai_5TOP_max: number;
  thai_5TOP_payout: number;
  thai_5TOP_discount: number;
  thai_6TOP_max: number;
  thai_6TOP_payout: number;
  thai_6TOP_discount: number;
  pp_enable: boolean;
  pp_cut_of_time: string;
  pp_1BOT_max: number;
  pp_1BOT_payout: number;
  pp_1BOT_discount: number;
  pp_1TOP_max: number;
  pp_1TOP_payout: number;
  pp_1TOP_discount: number;
  pp_2BOT_max: number;
  pp_2BOT_payout: number;
  pp_2BOT_discount: number;
  pp_2BOT_OE_max: number;
  pp_2BOT_OE_payout: number;
  pp_2BOT_OE_discount: number;
  pp_2BOT_OU_max: number;
  pp_2BOT_OU_payout: number;
  pp_2BOT_OU_discount: number;
  pp_2TOD_max: number;
  pp_2TOD_payout: number;
  pp_2TOD_discount: number;
  pp_2TOP_max: number;
  pp_2TOP_payout: number;
  pp_2TOP_discount: number;
  pp_2TOP_OE_max: number;
  pp_2TOP_OE_payout: number;
  pp_2TOP_OE_discount: number;
  pp_2TOP_OU_max: number;
  pp_2TOP_OU_payout: number;
  pp_2TOP_OU_discount: number;
  pp_3BOT_max: number;
  pp_3BOT_payout: number;
  pp_3BOT_discount: number;
  pp_3TOD_max: number;
  pp_3TOD_payout: number;
  pp_3TOD_discount: number;
  pp_3TOP_max: number;
  pp_3TOP_payout: number;
  pp_3TOP_discount: number;
  pp_3TOP_OE_max: number;
  pp_3TOP_OE_payout: number;
  pp_3TOP_OE_discount: number;
  pp_3TOP_OU_max: number;
  pp_3TOP_OU_payout: number;
  pp_3TOP_OU_discount: number;
  pp_4TOD_max: number;
  pp_4TOD_payout: number;
  pp_4TOD_discount: number;
  pp_4TOP_max: number;
  pp_4TOP_payout: number;
  pp_4TOP_discount: number;
  pp_5TOP_max: number;
  pp_5TOP_payout: number;
  pp_5TOP_discount: number;
  pp_6TOP_max: number;
  pp_6TOP_payout: number;
  pp_6TOP_discount: number;
  lao_enable: boolean;
  lao_cut_of_time: string;
  lao_L_2FB_max: number;
  lao_L_2FB_payout: number;
  lao_L_2FB_discount: number;
  lao_L_3TOD_max: number;
  lao_L_3TOD_payout: number;
  lao_L_3TOD_discount: number;
  lao_L_3TOP_max: number;
  lao_L_3TOP_payout: number;
  lao_L_3TOP_discount: number;
  lao_L_4TOD_max: number;
  lao_L_4TOD_payout: number;
  lao_L_4TOD_discount: number;
  lao_L_4TOP_max: number;
  lao_L_4TOP_payout: number;
  lao_L_4TOP_discount: number;
  lao_T_1BOT_max: number;
  lao_T_1BOT_payout: number;
  lao_T_1BOT_discount: number;
  lao_T_1TOP_max: number;
  lao_T_1TOP_payout: number;
  lao_T_1TOP_discount: number;
  lao_T_2BOT_max: number;
  lao_T_2BOT_payout: number;
  lao_T_2BOT_discount: number;
  lao_T_2TOD_max: number;
  lao_T_2TOD_payout: number;
  lao_T_2TOD_discount: number;
  lao_T_2TOP_max: number;
  lao_T_2TOP_payout: number;
  lao_T_2TOP_discount: number;
  lao_T_3TOD_max: number;
  lao_T_3TOD_payout: number;
  lao_T_3TOD_discount: number;
  lao_T_3TOP_max: number;
  lao_T_3TOP_payout: number;
  lao_T_3TOP_discount: number;
  lao_T_4TOD_max: number;
  lao_T_4TOD_payout: number;
  lao_T_4TOD_discount: number;
  lao_T_4TOP_max: number;
  lao_T_4TOP_payout: number;
  lao_T_4TOP_discount: number;
  update_dt: string;
  create_dt: string;
  member_id?: any;
  agent_id: number;
  update_by: number;
  update_on_amb: boolean;
}

export interface AgentShareSetting {
  id: number;
  agentAsk4betId: number;
  game_id: number;
  percent_own: number;
  percent_parent: number;
  agentName: string;
  partnerName: string;
  provider_id: number;
  game_type: string;
  game_name: string;
  provider_name: string;
}

export interface ShareSettingSeamless extends ShareSettingSeamlessAgent {
  PerOwn: number;
  PerApi: number;
}

export interface ShareSettingSeamlessAgent {
  Id: number;
  ProviderSeamless: string;
  GameCode: string;
  GameName: string;
  GameLogo?: string;
  GameType: string;
  Connected: boolean;
}

export interface MenuSeamlessGameType {
  label: string;
  value: string;
  enabled: boolean;
  count: number;
}

// export interface ProviderGame {
//   amb: ProviderGameSetting[];
//   bethub: ProviderGameSetting[];
//   gclub: ProviderGameSetting[];
//   klotto: ProviderGameSetting[];
//   superlot: ProviderGameSetting[];
//   ufa: ProviderGameSetting[];
//   seamless: ProviderGameSeamless[];
// }

// export interface ProviderGameSeamless {
//   Id: number;
//   ProviderSeamless: string;
//   GameCode: string;
//   GameName: string;
//   GameLogo: string;
//   GameType: string;
//   PerOwn: number;
//   PerApi: number;
//   Connected: boolean;
// }

// export interface ProviderGameSetting {
//   id: number;
//   provider_id: number;
//   game_type: string;
//   game_name: string;
//   provider_name: string;
//   provider_image?: any;
// }
export interface AgentUser {
  agent_code: string;
  agent_name: string;
  username: string;
  password: string;
  currency: string;
  agent_contact_name: string;
  type_agent: number;
  website?: any;
  credit_init: number;
  credit_remaining: number;
  status: string;
  create_dt: string;
  upline: string;
  using_pghard: boolean;
}
export interface ProviderGameAll {
  amb: ProviderGameTransfer[];
  bethub: ProviderGameTransfer[];
  gclub: ProviderGameTransfer[];
  klotto: ProviderGameTransfer[];
  superlot: ProviderGameTransfer[];
  ufa: ProviderGameTransfer[];
  seamless: ProviderGameSeamless[];
  betlimitcasino: BetLimitCasino[];
}

export interface BetLimitCasino {
  provider: string;
  game_code_product_Id: string;
  limit_name: string;
  ID: string;
  Description: string;
  min: number;
  max: number;
}

export interface ProviderGameSeamless {
  Id: number;
  Provider: string;
  GameCode: string;
  GameName: string;
  GameLogo: string;
  GameType: string;
  PercentSystems: number;
  PercentAPI: number;
  Connected: boolean;
  Seamless: boolean;
  QueryReplayVersion: number;
  Callbacksupports: boolean;
}

export interface ProviderGameTransfer {
  id: number;
  provider_id: number;
  game_type: string;
  game_name: string;
  provider_name: string;
  provider_image?: any;
}

export const seamlessGameTypeIconData = {
  slot: {
    key: 'slot',
    name: 'SLOT',
    icon: 'bi bi-controller',
  },
  casino: {
    key: 'casino',
    name: 'CASINO',
    icon: 'bi bi-dice-6',
  },
  sport: {
    key: 'sport',
    name: 'SPORT',
    icon: 'fa-solid fa-basketball',
  },
  lotto: {
    key: 'lotto',
    name: 'LOTTO',
    icon: 'bi bi-8-circle',
  },
  lotto_game: {
    key: 'lotto_game',
    name: 'LOTTO GAME',
    icon: 'bi bi-123',
  },
  game_card: {
    key: 'game_card',
    name: 'GAME CADE',
    icon: 'bi bi-suit-diamond',
  },
  cockfight: {
    key: 'cockfight',
    name: 'COCKFIGHT',
    icon: 'bi bi-egg',
  },
  arcade: {
    key: 'arcade',
    name: 'ARCADE',
    icon: 'bi bi-joystick',
  },
  esport: {
    key: 'esport',
    name: 'E-SPORT',
    icon: 'bi bi-nintendo-switch',
  },
  trading: {
    key: 'trading',
    name: 'TRADING',
    icon: 'bi bi-bar-chart',
  },
  poker: {
    key: 'poker',
    name: 'POKER',
    icon: 'bi bi-suit-spade',
  },
  keno: {
    key: 'keno',
    name: 'KENO',
    icon: 'bi bi-table',
  },
};

export interface SeamlessGameSetting {
  game_code: string;
  game_type: string;
  game_logo: string;
  game_name: string;
  percent_parent: number;
  percent_own: number;
  percent_given: number;
  is_connected: boolean;
  enabled: boolean;
  betlimitcasino_options?: BetLimitCasino[];
  bet_limit_id: string;
  ID: string;
  max_HUP_OU_OE?: number;
  min_HUP_OU_OE?: number;
  max_DC1X2?: number;
  min_DC1X2?: number;
  max_any?: number;
  min_any?: number;
  max_per_macth?: number;
  min_per_macth?: number;
}

export interface MemberSeamlessBetlimit {
  betLimitSport: SeamlessBetLimitSport[];
  betLimitEsport: SeamlessBetLimitEsport[];
  betLimitCasino: SeamlessBetLimitCasino[];
}

interface SeamlessBetLimitCasino {
  bet_limit_id: string;
  agent_id: number;
  member_id: number;
  game_provider: string;
  game_code: string;
  limit_name: string;
  ID: string;
  description: string;
  min: number;
  max: number;
  update_by: number;
  update_dt: string;
  create_dt: string;
}

interface SeamlessBetLimitEsport {
  bet_limit_id: string;
  agent_id: number;
  member_id: number;
  game_provider: string;
  game_code: string;
  min_per_macth: number;
  max_per_macth: number;
  update_by: number;
  update_dt: string;
  create_dt: string;
}

interface SeamlessBetLimitSport {
  bet_limit_id: string;
  agent_id: number;
  member_id: number;
  game_provider: string;
  game_code: string;
  min_HUP_OU_OE: number;
  max_HUP_OU_OE: number;
  min_DC1X2: number;
  max_DC1X2: number;
  min_any: number;
  max_any: number;
  min_per_macth: number;
  max_per_macth: number;
  update_by: number;
  update_dt: string;
  create_dt: string;
}

export interface AgentTransactionUplineDownline {
  agent_upline?: string;
  agent_downline: string;
  agent_upline_before?: number;
  agent_upline_after?: number;
  agent_downline_before: number;
  agent_downline_after: number;
  amount: number;
  create_dt: string;
  create_by_name: string;
  action: string;
}

export interface IProfigSharing {
  sport: ProfigSharing;
  casino: ProfigSharing;
  slot: ProfigSharing;
  esport: ProfigSharing;
  game_card: ProfigSharing;
  lotto: ProfigSharing;
  cockfight: ProfigSharing;
  trading: ProfigSharing;
  poker: ProfigSharing;
  arcade: ProfigSharing;
  keno: ProfigSharing;
}
export interface ProfigSharing {
  profit_sharing_defualt: profitSharingDefualt;
  profit_sharing: gamePercentAgent[];
}
export interface profitSharingDefualt {
  agent_id: number;
  agent_code: string;
  game_type: string;
  game_defualt_enable: boolean;
  game_defualt_profit: number;
  config_enable: boolean;
}
export interface gamePercentAgent {
  game_code: string;
  game_name: string;
  game_logo: string;
  game_type: string;
  percent_parent: number;
  percent_given: number;
  percent_own: number;
  game_seamless: boolean;
  game_enable: boolean;
  game_connected: boolean;
  casino_betlimit?: Gamecasinobetlimit;
  esports_betlimit: Gameesportsbetlimit;
  sport_betlimit?: Gamesportbetlimit;
}

// export interface Gameesportsbetlimit {
//   esports_betlimit_max: Esportsbetlimitmax;
//   esports_betlimit: Esportsbetlimitmax;
// }
// export interface Esportsbetlimitmax {
//   game_code: string;
//   min_per_macth: number;
//   max_per_macth: number;
// }
// export interface Gamecasinobetlimit {
//   casino_betlimit_list?: Casinobetlimitlist[];
//   casino_betlimit_selected?: Casinobetlimitlist;
// }
export interface Casinolimitlist {
  game_code: string;
  limit_name: string;
  ID: string;
  Description: string;
  min: number;
  max: number;
  prod: boolean;
}
// export interface Gamesportbetlimit {
//   sport_betlimit_max: Sportbetlimitmax;
//   sport_betlimit: Sportbetlimitmax;
// }
// export interface Sportbetlimitmax {
//   game_code: string;
//   min_HUP_OU_OE: number;
//   max_HUP_OU_OE: number;
//   min_DC1X2: number;
//   max_DC1X2: number;
//   min_any: number;
//   max_any: number;
//   min_per_macth: number;
//   max_per_macth: number;
// }

export interface AgentReload {
  sport: Sport[];
  casino: Casino[];
  slot: Slot[];
  esport: Esport[];
  game_card: Slot[];
  lotto: Slot[];
  cockfight: Slot[];
  trading: Slot[];
  poker: Slot[];
  arcade: any[];
  keno: any[];
}

interface Esport {
  game_code: string;
  game_name: string;
  game_logo: string;
  game_type: string;
  percent_parent: number;
  percent_given: number;
  percent_own: number;
  game_seamless: boolean;
  game_enable: boolean;
  game_connected: boolean;
  casino_betlimit: Gamecasinobetlimit;
  esports_betlimit: Gameesportsbetlimit2;
  sport_betlimit: Gamesportbetlimit2;
}

interface Gameesportsbetlimit2 {
  max: Esportsbetlimitmax;
  current: Esportsbetlimitmax;
}

interface Esportsbetlimitmax {
  game_code: string;
  min_per_macth: number;
  max_per_macth: number;
}

interface Slot {
  game_code: string;
  game_name: string;
  game_logo: string;
  game_type: string;
  percent_parent: number;
  percent_given: number;
  percent_own: number;
  game_seamless: boolean;
  game_enable: boolean;
  game_connected: boolean;
  casino_betlimit: Gamecasinobetlimit;
  esports_betlimit: Gameesportsbetlimit;
  sport_betlimit: Gamesportbetlimit2;
}

interface Casino {
  game_code: string;
  game_name: string;
  game_logo: string;
  game_type: string;
  percent_parent: number;
  percent_given: number;
  percent_own: number;
  game_seamless: boolean;
  game_enable: boolean;
  game_connected: boolean;
  casino_betlimit: Gamecasinobetlimit2;
  esports_betlimit: Gameesportsbetlimit;
  sport_betlimit: Gamesportbetlimit2;
}

interface Gamesportbetlimit2 {
  max?: any;
  current?: any;
}

interface Gamecasinobetlimit2 {
  list?: Casinobetlimitlist[];
  selected?: Casinobetlimitlist;
}

interface Casinobetlimitlist {
  game_code: string;
  limit_name: string;
  ID: string;
  Description: string;
  min: number;
  max: number;
  prod: boolean;
}

interface Sport {
  game_code: string;
  game_name: string;
  game_logo: string;
  game_type: string;
  percent_parcent: number;
  percent_given: number;
  percent_own: number;
  game_seamless: boolean;
  game_enable: boolean;
  game_connected: boolean;
  casino_betlimit: Gamecasinobetlimit;
  esports_betlimit: Gameesportsbetlimit;
  sport_betlimit: Gamesportbetlimit;
}

interface Gamesportbetlimit {
  max: Sportbetlimitmax;
  current: Sportbetlimitmax;
}

interface Sportbetlimitmax {
  game_code: string;
  min_HUP_OU_OE: number;
  max_HUP_OU_OE: number;
  min_DC1X2: number;
  max_DC1X2: number;
  min_any: number;
  max_any: number;
  min_per_macth: number;
  max_per_macth: number;
}

interface Gameesportsbetlimit {
  max?: any;
  current?: any;
}

interface Gamecasinobetlimit {
  list?: any;
  selected?: any;
}
